export default function sortByOrder<
  T extends { order: number }
>(elements: T[]): T[] {
  return [...elements].sort(
    (slideA, slideB) => slideA.order - slideB.order,
  );
}
